<template>
<div  id="Activitypeople">
  <v-header title="活动量管理"></v-header>
  <div class="ActivitypeopleCon">
    <!-- <div class="menuLeft">      
       <el-row class="tac">
      <el-col :span="24">
        <el-menu
          default-active="2"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose">
          <el-submenu index="1" >
            <template slot="title">
              <div @click="type">
                <i class="el-icon-location"></i>
                <span>活动类型统计</span>
              </div>              
            </template>
            <el-submenu index="1-4">
              <template slot="title">选项4</template>
              <el-menu-item index="1-4-1">选项1</el-menu-item>              
            </el-submenu>            
          </el-submenu>
          <el-menu-item index="1">
            <div @click="type">
              <i class="el-icon-location"></i>
              <span slot="title">活动类型统计</span>
            </div>
          </el-menu-item> 
          <el-menu-item index="2">
            <div @click="people">
              <i class="el-icon-menu"></i>
              <span slot="title">活动人次统计</span>
            </div>
          </el-menu-item>
        </el-menu>
      </el-col>
</el-row>
    </div> -->
    <!-- <div class="type" @click="type">
      <span>活动类型统计</span><i class="el-icon-arrow-right iconArrow floatRight"></i>
      </div>
      <div class="tree" v-show="tree">
      <el-tree :data="menuDirTree" :props="defaultProps" @node-click="setDirLocation"></el-tree>
      </div>
      <div class="people">活动人次统计</div> -->
    <div class="contentRight">
      <div class="rightcon">
        <el-row  >
        <!-- <el-col :span="4" class="Navigation">
        <div class="type" @click="type">
        活动类型统计
        </div>
        <div class="tree" v-show="tree">
        <el-tree :data="menuDirTree" :props="defaultProps" @node-click="setDirLocation"></el-tree>
        </div>
        <div class="people">活动人次统计</div>
        </el-col> -->
        <el-col :span="8" class="">
        <span>报表类型&nbsp;</span>
        <el-select v-model="value" @change="changeBranchtype(value)" >
        <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
        </el-option>
        </el-select>
        </el-col>

        <el-col :span="8" class="">
        <span>组织层级&nbsp;</span>
        <el-select v-model="childtype" @change="changetype()" >
        <el-option
        v-for="item in option"
        :key="item.value"
        :label="item.label"
        :value="item.value">
        </el-option>
        </el-select>
        </el-col>
        </el-row>

        <el-row style="margin-top:20px;">
        <el-col :span="8" class="">
        <span>报表时间&nbsp;</span>
        <el-date-picker
        v-model="value1"
        :type="datetype"
        :format="format"
        :editable='false'
        :clearable='false'
        :picker-options="pickerOptions0"
        placeholder="请选择报表时间"
        @change="datechange()"
        >
        </el-date-picker>
        </el-col>
        <el-col :span="2" :offset="12" class=""><el-button @click="check()" class="floatRight">查询</el-button></el-col>
        <el-col :span="2" class=""><el-button  @click="excel()" class="export floatRight" >导出</el-button></el-col>
        </el-row>
        
        <el-row style="margin-top:15px;">
        <el-col :span="24">
        <el-table class="tableCon"
            :data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)"
          >
            <el-table-column
              align="center"
              type="index"
              label="序号"
              width="100"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="name"
              label="组织架构"
              >
            </el-table-column>
            <el-table-column
              align="center"
              prop="startDate"
              label="开始时间"
              width="100"
              >
            </el-table-column>
            <el-table-column
              align="center"
              prop="endDate"
              label="结束时间"

            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="agentNum"
              label="应填写人数"

              >
            </el-table-column>
            <el-table-column
              align="center"
              prop="actualNum"
              label="实际填写人数"
              >
            </el-table-column>
            <el-table-column
              align="center"
              prop="answerNum"
              label="被批复人数"
              >
            </el-table-column>
            <el-table-column
              align="center"
              prop="answerDays"
              label="被批复天数"
              >
            </el-table-column>

          </el-table>
        </el-col>
        <el-col :span="24" class="pagesize pages" >
          <el-pagination
            @current-change="handleCurrentChange"
            :page-size= "pageSize"
            layout="total, prev, pager, next, jumper"
            :total="count">
          </el-pagination>
        </el-col>
        </el-row>
      </div>
    </div>
</div>
</div>
</template>
<script>
import url from '@/modules/url'
import api from '@/modules/api'
import vHeader from '@/layout/Header1.vue'
export default {
  components: {
    vHeader
  },
  data () {
    return {
      code: '',
      count: 0,
      day: '1',
      tree: false,
      pageSize: 10,
      currentPage: 1,
      tableData: [],
      pageNumber: 1,
      excelcode: '',
      pickerOptions0: {
        disabledDate (time) {
          // return time.getTime() > Date.now() - 8.64e7
          return time.getTime() > Date.now()
        },
        firstDayOfWeek:1
      },
      options: [{
        value: '1',
        label: '日报表'
      }, {
        value: '2',
        label: '月报表'
      }, {
        value: '3',
        label: '周报表'
      }],
      option: [{
        value: '1',
        label: 'T3'
      }, {
        value: '2',
        label: 'T4'
      }, {
        value: '3',
        label: '区'
      },
      {
        value: '4',
        label: '部'
      },
      {
        value: '5',
        label: '组'
      }
      ],

      value: '日报表',
      child: '组',
      childtype: '5',
      // childname:'组',
      // value1: new Date().setTime(new Date().getTime() - 3600 * 1000 * 24),
      value1: new Date(),
      value2: '',
      datetype: 'date',
      menuDirTree: [],
      defaultProps: {
        children: 'childGroup',
        label: 'name',
        id: 'code'
      },
      tabPosition: 'left',
      format: '',
      startDate: this.moment(new Date()).format('YYYY-MM-DD')
    }
  },
  methods: {
    // type () {
    //   this.$router.push({name: 'Activitycount'})
    // },
    // people () {
    //   this.$router.push({name: 'Activitypeople'})
    // },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    setDirLocation (data) {
      console.log(data.code)
      this.excelcode = data.code
      console.log(this.excelcode)
    },
    excel () {
      // console.log(this.tableData,"导出数据")
      if (this.tableData.length != 0 ) {
        let that = this
        let options = {
          orgType: that.childtype,
          // startDate: that.changetime(that.value1),
          startDate: that.startDate,
          flag: that.day,
          page: that.pageNumber,
          pageSize: 10,
          branchtype: that.code,
          excelTitle: '活动人次统计工作报表'
        }
        api.exportActivityGroupNum(options, function (res) {
          if (res.result.isSuccess) {
            console.log(res)
            const elink = document.createElement('a')
            elink.download = '活动人次统计工作报表.xls'

            elink.style.display = 'none'
            elink.href = res.data.loadUrl // URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            // URL.revokeObjectURL(blob)
            document.body.removeChild(elink)
          }
          console.log(res)
        })
      } else {
        // alert('数据为空')
        return false
      }
    },
    datechange () {
      console.log(this.value1)
      if (this.day == '1') {
        this.startDate = this.changetime(this.value1)
      }
      if (this.day == '2') {
        this.startDate = this.changetime(this.value1)
      }
      if (this.day == '3') {
        this.startDate = this.changetime(this.moment(this.value1).startOf('isoWeek'))
      }
      console.log(this.startDate)
    },
    changetime (data) {
      let getDate = new Date(data)
      let format = this.moment(getDate).format('YYYY-MM-DD')
      console.log(format)
      return format
    },
    check () {
      this.getActivityGroupNumWithPage()
    },
    getActivityGroupNumWithPage () {
      let that = this
      if(!that.value1){
        alert('请选择报表时间')
        return false
      }
      const loading = that.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let options = {
        orgType: that.childtype,
        // startDate: that.changetime(that.value1),
        startDate: that.startDate,
        flag: that.day,
        page: that.pageNumber,
        pageSize: 10,
        branchtype: that.code
      }
      // alert(JSON.stringify(options))
      api.getActivityGroupNumWithPage(options, function (res) {
        console.log(res)
        if (res.result.isSuccess === true) {
          let response = res.data.data
          console.log(res.data,'返回数据')
          that.tableData = []
          response.forEach(resData => {
            that.tableData.push(resData)
          })

          if(res.data.records){            
            that.count = Number(res.data.records)
            document.querySelector('.export').classList.remove('is-disabled')
          } else {
            that.count = 0
            document.querySelector('.export').classList.add('is-disabled')
          }
          // that.count = Number(res.data.records)
          // alert(that.count)

          loading.close()
        } else {
          loading.close()
          alert('请求异常')
        }
      })
    },
    handleCurrentChange (val) {
      this.pageNumber = val
      console.log(this.pageNumber)
      this.getActivityGroupNumWithPage()
    },
    getAgentChannel () {
      let that = this
      api.getAgentChannel({}, function (res) {
        if (res.result.isSuccess === true) {
          that.code = res.data[0].code
          that.getActivityGroupNumWithPage()
        }
      })
    },
    changeBranchtype (value) {
      console.log(this.value1)
      if (value === '1') {
        this.value1 = new Date()
        this.startDate = this.changetime(this.value1)
        this.format = ''
        this.datetype = 'date'
        this.day = '1'
      }
      if (value === '2') {
        this.value1 = this.moment().startOf('month')
        this.startDate = this.changetime(this.value1)
        this.format = ''
        this.datetype = 'month'
        this.day = '2'
      }
      if (value === '3') {
        this.value1 = this.moment().startOf('isoWeek')
        this.startDate = this.changetime(this.value1)
        this.format = 'yyyy 第 WW 周'
        this.datetype = 'week'
        this.day = '3'
      }
    },
    changetype () {
      var value = this.changetype
      if (value === '1') {
        this.childtype = '1'
        this.child = 'T3'
      }
      if (value === '2') {
        this.childtype = '2'
        this.child = 'T4'
      }
      if (value === '3') {
        this.childtype = '3'
        this.child = '区'
      }
      if (value === '4') {
        this.childtype = '4'
        this.child = '部'
      }
      if (value === '5') {
        this.childtype = '5'
        this.child = '组'
      }
    }
  },
  mounted () {
    this.getAgentChannel()
    // document.querySelector('.el-menu-item').classList.add('is-active')
  },
  
}
</script>

<style lang="scss" scoped>
// .Navigation{
//   background: #fff;
//   height:93vh;
// }
.body{
    font-family:"Microsoft YaHei";
    font-size: 19px;
    /* background: #fff; */
    width:100%;
    min-height: 100%;
    // overflow-x: hidden;
}
#Activitypeople{
  // padding-top: 60px;
  height:100%;
  box-sizing: border-box;
}
.ActivitypeopleCon{
  height: 100%;
  // overflow: hidden;
  /* min-height: 100%; */
  box-sizing: border-box;
  padding-top: 20px;
  -webkit-box-sizing: border-box;
}
.menuLeft{
  width:14%;
  float: left;
  height: 100%;
  background: #ffffff;
}
.contentRight{
  width:100%;
  float: left;
  // padding-top: 20px;
}
.rightcon{
  width: 96%;
  margin: 0 auto;
}
.tableCon{
  margin-top: 20px;
}
// .exportBtn{ margin-top: 20px;}
.pages{
  display:flex;
  justify-content: center;
  align-items:center;
  background-color: #ffffff;
  height: 100px;
}

.type,.tree,.people{
  width: 100%;
  /* text-align: center; */
  padding:0 20px;
  box-sizing: border-box;
}
.type{
  margin-top: 20px;
  height: 35px;
  line-height: 35px;
  color:#3D62AD
}
.people{
  margin-top: 10px;
  height: 35px;
  line-height: 35px;
}
// .tree{
//   padding-top: 10px;
// }
// .iconArrow{
//   height: 35px;
//   line-height: 35px;
// }


.userinfo{ width: 94%;margin: 0 auto;background: #fff; margin-top:2%;}
.item{
    width: 88%;
    height: auto;
    margin: 0 auto;
    line-height: 53px;
    border-bottom: 1px solid #f5f5f5;
    overflow: hidden;
}
.item.arrow{ position:relative;}
.item.arrow i{color:#D4D4D4; position:absolute; right:10px; top:50%; margin-top:-9px; cursor:pointer;}
.item.arrow span{color: #3D62AD;cursor:pointer;}
.line{
    line-height: 33px;
}
.photo{
    width:30%;
    float: left;
}
.photo img {
    float: right;
}
.info{
    width:70%;
    float: left;
}
label{
    float: left;
    display: block;
    width: 31%;
    color: #919191;
}

.userinfo span{
    float: left;
    display: block;
    width: 69%;
}
.el-col {
    border-radius: 4px;
}
.grid-content {
    border-radius: 4px;
    padding-top: 40px;
    min-height: 75vh;
}
// .type,.tree,.people{
//   width: 100%;
//   text-align: center
// }
// .people{
//   color:#3D62AD
// }
// .type,.people{
//   margin-top: 20px
// }
.pagesize{
  margin-bottom: 20px
}
#Activitypeople /deep/ .el-pagination{
  text-align: center!important
}
// #Activitypeople /deep/ .el-menu-item.is-active{
//   background-color: #ecf5ff;
// }
</style>



// WEBPACK FOOTER //
// src/pages/Activitycount/Activitypeople.vue